module.exports = __webpack_public_path__ + "static/media/map6-1.56040db0.png";